import { Button, Form, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { handleOtpTimerValue } from "containers/services/data.transformers";
import { useEffect } from "react";
import OtpTimer from "otp-timer";
import Input from "components/inputs";

const Otp = ({
  btnLoading,
  data,
  disabled,
  formRef,
  loading,
  numInputsOtp = 6,
  onFinish,
  onResend,
  onValuesChange,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    // بررسی اینکه آیا مرورگر Web OTP API را پشتیبانی می‌کند
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator?.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac?.signal,
        })
        .then(async (otpCredential) => {
          if (otpCredential && otpCredential?.code) {
            // اگر OTP دریافت شد، آن را به فرم وارد کنید
            await formRef.current.setFieldsValue({ otp: otpCredential?.code });
            await formRef.current.submit(); // ارسال خودکار فرم
          }
        })
        .catch((error) => {
          console.error("OTP retrieval failed:", error); // خطاها را لاگ می‌کنیم
        });

      return () => ac.abort();
    }
  }, []); // تنها یک بار اجرا می‌شود

  const handleOtpChange = (e) => {
    if (e.length === 6) {
      form.submit(); // زمانی که کد 6 رقمی وارد شد، فرم ارسال می‌شود
    }
  };

  return (
    <Form
      form={form}
      name="otp_form"
      ref={formRef}
      onFinish={onFinish}
      onValuesChange={onValuesChange}
    >
      <div className="grid grid-cols-1 place-content-center">
        <span className="body-14px-regular text-gray-1 mt-20 mb-6 text-center otp-description">
          کد ارسال شده به{" "}
          <span className="body-14px-demibold">{data?.receiver}</span> را وارد
          کنید.
        </span>
        <Input
          name="otp"
          required
          type="otp"
          numInputsOtp={numInputsOtp}
          separatorOtp={""}
          onChange={handleOtpChange}
        />
        <div className="otp-timer mx-auto text-end mt-2 mb-20 w-72 sm:w-auto sm:text-center">
          {loading ? (
            <Spin />
          ) : (
            <OtpTimer
              seconds={handleOtpTimerValue(data)?.seconds}
              minutes={handleOtpTimerValue(data)?.minutes}
              resend={onResend}
              text=" "
              ButtonText={t("resend-otp")}
              background={"#fff"}
            />
          )}
        </div>
        <Button
          block
          className={`${disabled ? "disabled-button-large" : "primary-button-large"
            } justify-center`}
          disabled={disabled}
          htmlType="submit"
          loading={loading || btnLoading}
        >
          {t("accept")}
        </Button>
      </div>
    </Form>
  );
};

export default Otp;
